module.exports = __webpack_public_path__ + "static/media/运动感应模块.907fdc6d.png";